import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { TDigitalJourneyFormData } from '../../types'
import { useHistory } from 'react-router'
import { useDigitalJourney } from '@cannect/hooks/useDigitalJourney'
import { useConfirmIdentityMutation } from '@cannect/services/resources/digitalJourney'
import { zodResolver } from '@hookform/resolvers/zod'
import { FORM_SCHEMAS } from '../../constants'
import moment from 'moment'

type TFormFields = TDigitalJourneyFormData['confirm_identity_document']
export const useConfirmIdentificationStep = () => {
  const { formData, updateFormData } = useDigitalJourney()
  const confirmIdentityMutation = useConfirmIdentityMutation()
  const history = useHistory()

  const formatBirthdayToDisplay = (birthday?: string) => {
    if (!birthday) return ''

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(birthday)) {
      return birthday
    }

    const date = moment(birthday, [moment.ISO_8601, 'YYYY-MM-DD', 'DD/MM/YYYY'], true)
    return date.isValid() ? date.format('DD/MM/YYYY') : birthday
  }

  const confirmIdentificationForm = useForm<TFormFields>({
    defaultValues: {
      ...formData?.confirm_identity_document,
      birthday: formatBirthdayToDisplay(formData?.confirm_identity_document?.birthday)
    },
    resolver: zodResolver(FORM_SCHEMAS.confirm_identity_document)
  })

  const {
    handleSubmit,
    control,
    formState: { isSubmitting }
  } = confirmIdentificationForm

  const watchedFields = useWatch({ control })

  useEffect(() => {
    updateFormData({
      confirm_identity_document: {
        full_name: watchedFields.full_name || '',
        birthday: watchedFields?.birthday || '',
        cpf: watchedFields.cpf || '',
        rg: watchedFields.rg || ''
      }
    })
  }, [watchedFields])

  const onSubmit = (data: TFormFields) => {
    if (!formData.common_fields?.digital_journey_id) return

    // eslint-disable-next-line consistent-return
    return confirmIdentityMutation.mutateAsync(
      {
        digital_journey_id: formData.common_fields?.digital_journey_id,
        ...data
      },
      {
        onSuccess: (response) => {
          updateFormData({
            confirm_identity_document: {
              ...data
            }
          })
          if (response?.next_step) {
            history.push(response.next_step)
          }
        }
      }
    )
  }
  return {
    confirmIdentificationForm,
    onSubmit,
    control,
    isSubmitting,
    handleSubmit
  }
}
